/* tslint:disable:max-line-length */
import React from 'react'

interface Props {
    width?: number
    height?: number,
    fill?: string,
    stroke?: string
}

interface State {}

export default class BasketIcon extends React.Component<Props, State> {

    public render() {

        let {
            fill = '#FFF',
            stroke,
            width = 20,
            height = 19
        } = this.props

        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
                <path stroke={stroke} fill={fill} fillRule="evenodd" d="M0 5.125v4.94h1.342l2.431 8.242h12.74l2.431-8.242h1.336v-4.94h-5.2L14.003 0l-1.016.213 1.04 4.912H6.26L7.3.213 6.284 0 5.2 5.125H0zm15.73 12.139H4.55l-2.125-7.202h15.43l-2.125 7.202zm3.51-11.1v2.86H1.04v-2.86h18.2z"/>
            </svg>
        )
    }
}



// WEBPACK FOOTER //
// ./src/_assets/icons/Basket.tsx